export const collapseElement = (el: HTMLElement): Promise<void> => {
  return new Promise((resolve) => {
    // Make sure it has a current height in pixels
    if (el) {
      const currentHeight = el.offsetHeight;
      el.style.height = currentHeight + 'px';

      // Force a reflow so the transition will actually occur
      void el.offsetHeight;

      // Apply the transition
      el.style.height = '0px';

      // Resolve the promise when transition ends
      const onTransitionEnd = () => {
        el.style.transition = '';
        el.style.height = '';
        el.removeEventListener('transitionend', onTransitionEnd);
        resolve();
      };
      el.addEventListener('transitionend', onTransitionEnd);
    }
  });
};
